const KEY = 'numerology.lifecycleAttribution';

export interface LifecycleAttribution {
  sourceCampaign: string;
  campaignStep: number;
  variantId: string;
  productId?: string | null;
}

export function rememberLifecycleAttribution(value: LifecycleAttribution): void {
  sessionStorage.setItem(KEY, JSON.stringify(value));
}

export function readLifecycleAttribution(): LifecycleAttribution | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as LifecycleAttribution;
    if (!parsed || typeof parsed.sourceCampaign !== 'string') return null;
    return parsed;
  } catch {
    return null;
  }
}
